
import cx from 'classnames'
import T from 'prop-types'
import React from 'react'
import {
  EditorInput
} from 'pw-drafty'
// import {
//   splitOutsideQuotes
// } from 'pw-validators'
import {
  // getEntityTypesFromDelimiter,
  parseQueryString
} from './queryUtils'
// import {
//   CASE_INSENSITIVE,
//   QUERY_OPERATORS,
//   QUERY_PART_TYPES
// } from './constants'
// import {
//   parseQuery
// } from './queryParser'


/**
 * Lucene style query input component
 * Validator supplied in Schema
 *
 * Grouping: () Nested infinitely
 * Conjunctions: and|or
 * Clause
 * *
 * Numeric
 * Numeric Range
 * IP/CIDR (IPv4 & IPv6)
 * String
 * Multi-string (comma separated?)
 * Geolocation (radius/latLonBounds?)
 * Country?
 * Enum / Fixed Value options
 * Date Range
 *
 * custom token (tags, Device Icons, Users, etc.)
 * *
 * TODO handle pasted text/lists?
 * https://github.com/facebook/draft-js/issues/195
 * Paste text -> handlePastedText() ->
 * parse out custom entity matches from the raw pasted string ->
 * return false so raw text does not enter editor
 *
 * TODO handle pasted files...?
 *
 * TODO support "recent" or "popular" query fields or values?
 *
 * TODO rotating "placeholder" style search suggestions
 * *
 * TODO (optionally) auto-close parentheses when selection is a range (not collapsed)
 * e.g. if the user selects a coupe words and hits "(", we insert a ")" at the end of the range
 *
 * TODO auto-enclose when OR is inserted
*/











// const QUERY_SCHEMA_PART_SHAPE = T.shape({
//   fieldName: T.string.isRequired, // AKA: queryField,
//   label: T.string.isRequired,
//   type: T.oneOf(Object.keys(QUERY_INPUT_TYPE_NAMES)).isRequired, // TODO allow custom types
//   options: T.array,
//   operatorOptions: T.array,
//   className: T.oneOfType([T.string, T.func]), // String or getter function(queryValueString)
//   tooltip: T.oneOfType([T.string, T.func]), // String or getter function(queryValueString)
//   // negatable?
// })


// const bracketsRegex = /\[([^\]]+)\]/g








// TODO add custom blockRenderer to...
// - insert index data-attributes for line numbers
// - add tooltip to rule body to open a modal "expanded" view with all settings
//   on separate lines


function queryInputBlockStyleFn (contentBlock) {
  const {
    // disabled,
    invalid
  } = contentBlock.getData().toObject()
  return cx(`query_input_block`, {
    // 'is_disabled': disabled,
    'is_invalid': invalid
  })
}



export default class extends React.Component {
  static displayName = 'QueryInput';

  static propTypes = {
    allowUnknownFields: T.bool,
    className: T.string,
    initialValue: T.string,
    onChange: T.func,
    onChangeArgs: T.array,
    onReturnPressed: T.func,
    placeholder: T.string,
    // schema: T.objectOf(QUERY_SCHEMA_PART_SHAPE).isRequired
    schema: T.object.isRequired, // FIXME update this
    validate: T.func, // optional additional validation. Called with (queryPart, schema)
  }

  static defaultProps = {
    allowUnknownFields: false,
    placeholder: "field=value AND (field2!=value2 OR field3=value3,value4)",
    onChangeArgs: []
  }

  constructor(props) {
    super(props)
    this.state = this._getTypeaheadOptionsFromSchema(props.schema)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.schema._schemaUpdatedAt !== nextProps.schema._schemaUpdatedAt) {
      this.setState(this._getTypeaheadOptionsFromSchema(nextProps.schema))
    }
  }

  clear = () => {
    if (this._editorInputRef) {
      this._editorInputRef.clear()
    }
  }

  _getTypeaheadOptionsFromSchema = (schema) => {
    const fieldOptions = []
    const fieldsToValueOptions = {}
    const fieldsToOperatorOptions = {}

    for (const partDisplayName in schema) {
      if (schema.hasOwnProperty(partDisplayName)) {
        const part = schema[partDisplayName]

        if (part.isQueryOption) {
          fieldOptions.push({
            // name: partDisplayName,
            name: part._originalLabel || part.label, // use original case as typeahead option
            id: part.fieldName
          })
          if (part.options && part.options.length > 0) {
            fieldsToValueOptions[partDisplayName] = part.options.map(opt => {
              return {
                name: opt,
                id: opt
              }
            })
          }
          if (part.operatorOptions && part.operatorOptions.length > 0) {
            fieldsToOperatorOptions[partDisplayName] = part.operatorOptions.map(opt => {
              return {
                name: opt,
                id: opt
              }
            })
          }
        }
      }
    }

    return {
      fieldOptions: fieldOptions,
      fieldsToValueOptions: fieldsToValueOptions,
      fieldsToOperatorOptions: fieldsToOperatorOptions
    }
  }

  _onChange = (rawTextBlocks, blockData) => {
    const {
      onChange,
      onChangeArgs
    } = this.props
    if (onChange) {
      onChange(rawTextBlocks, blockData, ...onChangeArgs)
    }
  }

  _parseQueryString = (inputString, parserOptions, caretOffset) => {
    const {
      allowUnknownFields,
      schema,
      validate
    } = this.props
    const {
      // editorSchema
      fieldOptions,
      fieldsToValueOptions,
      fieldsToOperatorOptions
    } = this.state

    if (!schema) {
      return {
        IDEState: [],
        IDEStateData: {
          // disabled: isDisabled,
          invalid: true,
          loadingSchema: true
        },
        typeaheadState: null
      }
    }

    return parseQueryString(inputString, schema, {
      allowUnknownFields,
      validate,
      caretOffset,
      optionMaps: {
        fields: fieldOptions,
        operatorsByField: fieldsToOperatorOptions,
        valuesByField: fieldsToValueOptions
      }
    })
  }

  _onFocus = () => {
    this.setState({hasFocus: true})
  }

  _onBlur = () => {
    this.setState({hasFocus: false})
  }

  _handleReturn = (optionSelected) => {
    const {
      onReturnPressed
    } = this.props
    if (!optionSelected && onReturnPressed) {
      onReturnPressed()
    }
  }

  _handleEditorInputRef = (el) => {
    this._editorInputRef = el
  }

  render() {
    const {props, state} = this
    const {
      className,
      initialValue,
      placeholder,
      schema
    } = props
    const {
      hasFocus
    } = state

    return (
      <div className={ `query_input ${ className } ${ hasFocus ? 'has_focus' : '' }` }>
        <EditorInput
          blockStyleFn={ queryInputBlockStyleFn }
          className={ `query_input_editor` }
          getTypeaheadRange={ this._getTypeaheadRange }
          initialValue={ initialValue }
          onBlur={ this._onBlur }
          onChange={ this._onChange }
          onFocus={ this._onFocus }
          onHandleReturn={ this._handleReturn }
          parser={ this._parseQueryString }
          placeholder={ placeholder }
          ref={ this._handleEditorInputRef }
          schema={ schema }
        />
      </div>
    )
  }
}
